import { TimelineMax, Linear, Power3 } from 'gsap/all';

export default function link(cursor, type) {
  const ease = Power3.easeInOut;
  const scale = window.innerWidth < 1024 ? 1 : !type ? 2 : 0.75;
  const hue = 120;
  const saturation = 0.8;

  const tl = new TimelineMax({
    paused: true,
    smoothChildTiming: true,
  });
  tl.addLabel('start')
    .to(cursor, 0.6, {
      hue,
      saturation,
      ease: Linear.easeNone,
    }, 'start')
    .to(cursor, 1.5, {
      scale,
      ease,
    }, 'start');
  return tl;
}